import { catchFaceOfDeepWeb } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/catchFaceDrawer/catchFaceOfDeepWeb'
import { catchFaceOfThumbParts } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/catchFaceDrawer/catchFaceOfThumbParts'

// 普通・深めのウェブ時の捕球面
const normalWebCatchFaceDrawer = (ctx: CanvasRenderingContext2D, catchFaceColor: string, stitchColor: string): void => {
  catchFaceOfThumbParts(ctx, catchFaceColor)
  catchFaceOfDeepWeb(ctx, catchFaceColor, stitchColor)
}

export const catchFaceDrawer = (ctx: CanvasRenderingContext2D, catchFaceColor: string, stitchColor: string): void => {
  normalWebCatchFaceDrawer(ctx, catchFaceColor, stitchColor)
}
